import { render } from "./LocationOpeningHoursForm.vue?vue&type=template&id=45e35d8a"
import script from "./LocationOpeningHoursForm.vue?vue&type=script&lang=js"
export * from "./LocationOpeningHoursForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__